/*
 * cart-insurance.js — case « Assurance colis » dans le panier.
 * Version Helvia (thème Shrine).
 *
 * L'assurance est une vraie ligne de panier (un produit Shopify). Cocher
 * l'ajoute, décocher la retire.
 *
 * La case est cochée par défaut : l'assurance est ajoutée automatiquement.
 * Le refus du client est mémorisé (localStorage) — sans ça, elle se
 * rajouterait toute seule juste après avoir été décochée.
 */
(function () {
  'use strict';

  // Le fichier est référencé par le tiroir ET par le pied de la page panier :
  // sur /cart il serait exécuté deux fois, et chaque bascule compterait double.
  if (window.__cartInsuranceReady) return;
  window.__cartInsuranceReady = true;

  var OPTOUT_KEY = 'helvia_insurance_optout';
  var busy = false;

  function el() {
    return document.querySelector('[data-cart-insurance]');
  }

  function optedOut() {
    try { return localStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }

  function setOptOut(v) {
    try {
      if (v) localStorage.setItem(OPTOUT_KEY, '1');
      else localStorage.removeItem(OPTOUT_KEY);
    } catch (e) { /* navigation privée */ }
  }

  function setBusy(state) {
    busy = state;
    var wrap = el();
    if (!wrap) return;
    var box = wrap.querySelector('[data-insurance-toggle]');
    var spinner = wrap.querySelector('[data-insurance-spinner]');
    if (box) box.disabled = state;
    if (spinner) spinner.hidden = !state;
    wrap.classList.toggle('is-busy', state);
  }

  function cartUrl(path) {
    var root = (window.routes && window.routes.root_url) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + path;
  }

  function innerFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  // Le tiroir sait se re-rendre seul ; sur la page panier il faut recharger
  // pour que les totaux et les lignes soient justes.
  //
  // On ne passe pas par cart-drawer.renderContents() du thème : cette méthode
  // rouvre systématiquement le tiroir, ce qui le ferait surgir lors de l'ajout
  // automatique. On remplace donc `.drawer__inner` nous-mêmes — c'est
  // exactement la cible utilisée par CartDrawerItems.getSectionsToRender().
  //
  // `cart` (optionnel) est le panier renvoyé par /cart/change.js. Il sert à
  // rétablir la classe is-empty, qui vit sur <cart-drawer> — donc hors de la
  // zone remplacée. Sans elle, vider le panier laisse un tiroir blanc au lieu
  // du message « Votre panier est vide ».
  function refreshCart(cart) {
    // <cart-items> n'existe que sur la page panier ; le tiroir utilise
    // <cart-drawer-items>, un autre nom de balise.
    var onCartPage = !!document.querySelector('cart-items');
    var drawer = document.querySelector('cart-drawer');
    var inner = drawer && drawer.querySelector('.drawer__inner');

    if (onCartPage || !inner) {
      window.location.reload();
      return;
    }

    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerHtml = innerFrom(sections['cart-drawer'] || '', '.drawer__inner');
        if (drawerHtml === null) {
          window.location.reload();
          return;
        }
        inner.innerHTML = drawerHtml;

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bubbleHtml = innerFrom(sections['cart-icon-bubble'], '.shopify-section');
          var bubbleTarget = bubble.querySelector('.shopify-section') || bubble;
          if (bubbleHtml !== null) bubbleTarget.innerHTML = bubbleHtml;
        }

        if (cart && typeof cart.item_count === 'number') {
          var empty = cart.item_count === 0;
          drawer.classList.toggle('is-empty', empty);
          inner.classList.toggle('is-empty', empty);
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', empty);
        }

        // NE PAS publier PUB_SUB_EVENTS.cartUpdate ici.
        // <cart-drawer-items> hérite de CartItems.onCartUpdate(), qui va
        // chercher /cart?section_id=main-cart-items et écrase le tiroir avec
        // le balisage de la PAGE panier (« Votre panier » + « Continuer les
        // achats » + mise en page cassée). Le tiroir et la pastille sont déjà
        // à jour ci-dessus, personne d'autre n'a besoin d'être prévenu.

        setBusy(false);
      })
      .catch(function (e) {
        console.error('[cart-insurance] refreshCart', e);
        window.location.reload();
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function add(variantId) {
    return post(cartUrl('cart/add.js'), { items: [{ id: Number(variantId), quantity: 1 }] });
  }

  function remove(lineKey) {
    return post(cartUrl('cart/change.js'), { id: lineKey, quantity: 0 });
  }

  // /cart/change.js renvoie le panier à jour : on le transmet à refreshCart
  // pour qu'il rétablisse l'état vide sans recharger la page.
  function removeThenRefresh(lineKey) {
    return remove(lineKey).then(function (cart) { refreshCart(cart); });
  }

  function fail(e) {
    console.error('[cart-insurance]', e);
    setBusy(false);
  }

  /* --- Actions ------------------------------------------------------- */

  function onToggle(checkbox) {
    if (busy) return;
    var wrap = el();
    if (!wrap) return;

    // Retour visuel immédiat : l'aller-retour serveur prend ~1 s.
    wrap.classList.toggle('is-checked', checkbox.checked);

    setBusy(true);

    if (checkbox.checked) {
      setOptOut(false);
      add(wrap.dataset.variantId).then(function () { refreshCart(); }).catch(fail);
    } else {
      // Le refus doit être mémorisé, sinon l'ajout auto le réactive aussitôt.
      setOptOut(true);
      var key = wrap.dataset.lineKey;
      if (!key) { setBusy(false); return; }
      removeThenRefresh(key).catch(fail);
    }
  }

  // Ajout automatique (case cochée par défaut), et nettoyage si l'assurance
  // se retrouve seule au panier.
  function reconcile() {
    if (busy) return;
    var wrap = el();
    if (!wrap) return;

    var inCart = wrap.dataset.inCart === 'true';
    var others = parseInt(wrap.dataset.otherItems, 10) || 0;

    // Plus aucun produit : une assurance seule au panier n'a pas de sens.
    if (inCart && others === 0) {
      setBusy(true);
      removeThenRefresh(wrap.dataset.lineKey).catch(fail);
      return;
    }

    if (inCart) return;
    if (wrap.dataset.defaultChecked !== 'true') return;
    if (optedOut()) return;
    if (others === 0) return;

    setBusy(true);
    add(wrap.dataset.variantId).then(function () { refreshCart(); }).catch(fail);
  }

  /* --- Écouteurs ------------------------------------------------------ */

  // Délégation : le tiroir panier est re-rendu à chaque modification, les
  // écouteurs posés directement sur la case seraient perdus.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-insurance-toggle')) {
      onToggle(e.target);
    }
  });

  // Le label entoure la case : sans ça, un clic fermerait/ouvrirait autre chose.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.cart-insurance__row')) e.stopPropagation();
  });

  function watchCart() {
    var target = document.getElementById('CartDrawer') || document.body;
    var timer = null;
    var observer = new MutationObserver(function () {
      // Un re-render déclenche plusieurs mutations d'affilée : on attend
      // qu'elles se calment avant de relire l'état du panier.
      clearTimeout(timer);
      timer = setTimeout(reconcile, 250);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    reconcile();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
